<a [routerLink]="{ cxRoute: 'wishlist' } | cxUrl">
  <sd-tab-bar-item-legacy
    icon="FAVORITE"
    [isActive]="isActive$ | async"
    [badgeCount]="currentCount$ | async"
  ></sd-tab-bar-item-legacy>
</a>
